/**
 * Split a full name into first/last for notification fields.
 * Returns { firstName, lastName, parsed } — parsed is false for empty or single-token names.
 */
export function parsePersonName(fullName) {
  const trimmed = String(fullName || '')
    .trim()
    .replace(/\s+/g, ' ');
  if (!trimmed) {
    return { firstName: '', lastName: '', parsed: false };
  }
  const parts = trimmed.split(' ');
  if (parts.length === 1) {
    return { firstName: '', lastName: '', parsed: false };
  }
  return {
    firstName: parts.slice(0, -1).join(' '),
    lastName: parts[parts.length - 1],
    parsed: true,
  };
}
